import { Directive } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from "@angular/forms";

import { isValidIpv4Address } from "../services/format-validation";

/**
 * Makes a template-driven control genuinely invalid when its value is not a complete IPv4
 * address, so the control's own state says so.
 *
 * BUG-085: the Geo IP Exception in-page modal already refused a malformed address and rendered a
 * message, but it decided validity in a component field, outside the form model. The consequence
 * is what QA reported: the input stayed `ng-valid` with no `aria-invalid`, Save stayed enabled, and
 * nothing a screen reader or an automated check looks at reflected the refusal - so from the
 * outside "Save does nothing and says nothing". The routed version of the same form gets this for
 * free because it goes through Formly's `ip` validator; this gives the hand-rolled form the same
 * footing rather than a second, parallel notion of validity.
 *
 * Empty is left to `required`: emptiness and format are different messages, and conflating them
 * is what made the original defect (BUG-049) hard to read.
 */
@Directive({
  providers: [{ multi: true, provide: NG_VALIDATORS, useExisting: Ipv4ValidatorDirective }],
  selector: "[dirIpv4]",
  standalone: true
})
export class Ipv4ValidatorDirective implements Validator {
  public validate(control: AbstractControl): ValidationErrors | undefined {
    const value: string = (control.value ?? "").toString().trim();

    if (value === "") {
      return undefined;
    }

    return isValidIpv4Address(value) ? undefined : { ipv4: true };
  }
}
